import React, { useState, useCallback, useEffect } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import {
  Box,
  Typography,
  Divider,
  Card,
  CardMedia,
  Button,
  Grid,
  IconButton,
  CircularProgress,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import typographyStyles from "../../../theme/Typography";
import BasicButtons from "../../../components/Button";
import InputField from "../../../components/InputField";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-hot-toast";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  AccessibilityHelp,
  Alignment,
  Autoformat,
  AutoLink,
  List,
  ListProperties,
  Autosave,
  BlockQuote,
  Bold,
  CodeBlock,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Heading,
  HorizontalLine,
  Indent,
  IndentBlock,
  Italic,
  Link,
  Paragraph,
  SelectAll,
  Style,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  Underline,
  Undo,
} from "ckeditor5";
import { postDataHandler, postDataHandlerWithToken } from "../../../apiconfig/service";
import backBtn from "../../../assets/backBtn.svg";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import Cropper from "react-easy-crop";
import ReactModal from "react-modal";
import { commonGridStyle, modalStyles } from "../../../scss/style";
import { cropAndUploadImage } from "../../../utils/cropAndUploadImage";
import RemoveIcon from "@mui/icons-material/Remove";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";

import { topicSchema } from "../../../schema";

const addEditStyle = {
  addEditTitle: {
    ...typographyStyles.h4,
  },
  addEditLabel: {
    ...typographyStyles.h6,
  },
  addRemoveButton: {
    textTransform: "none",
    backgroundColor: "rgb(225,140,168)",
    color: "white",
    fontWeight: "400",
    fontSize: "15px",
    fontFamily: "'Poppins', sans-serif",
    boxShadow: "0 0 0.938rem 0 rgba(0, 0, 0, 0.2)",
    marginTop: "2px",
    marginLeft: "2px",
    "&:hover": {
      backgroundColor: "white",
      color: "rgb(225,140,168)",
    },
  },
};
const editorConfig = {
  toolbar: {
    items: [
      "undo",
      "redo",
      "|",
      "heading",
      "style",
      "|",
      "fontSize",
      "fontFamily",
      "fontColor",
      "fontBackgroundColor",
      "|",
      "bold",
      "italic",
      "underline",
      "bulletedList",
      "numberedList",

      "|",
      "horizontalLine",
      "link",
      "insertTable",
      "blockQuote",
      "codeBlock",
      "|",
      "alignment",
      "|",
      "outdent",
      "indent",
    ],
    shouldNotGroupWhenFull: false,
  },
  plugins: [
    AccessibilityHelp,
    Alignment,
    Autoformat,
    AutoLink,
    Autosave,
    BlockQuote,
    Bold,
    CodeBlock,
    Essentials,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    HorizontalLine,
    Indent,
    IndentBlock,
    Italic,
    Link,
    Paragraph,
    SelectAll,
    List,
    ListProperties,

    TextTransformation,
    Underline,
    Undo,
  ],
  fontFamily: {
    supportAllValues: true,
  },
  fontSize: {
    options: [10, 12, 14, "default", 18, 20, 22],
    supportAllValues: true,
  },
  heading: {
    options: [
      {
        model: "paragraph",
        title: "Paragraph",
        class: "ck-heading_paragraph",
      },
      {
        model: "heading1",
        view: "h1",
        title: "Heading 1",
        class: "ck-heading_heading1",
      },
      {
        model: "heading2",
        view: "h2",
        title: "Heading 2",
        class: "ck-heading_heading2",
      },
      {
        model: "heading3",
        view: "h3",
        title: "Heading 3",
        class: "ck-heading_heading3",
      },
      {
        model: "heading4",
        view: "h4",
        title: "Heading 4",
        class: "ck-heading_heading4",
      },
      {
        model: "heading5",
        view: "h5",
        title: "Heading 5",
        class: "ck-heading_heading5",
      },
      {
        model: "heading6",
        view: "h6",
        title: "Heading 6",
        class: "ck-heading_heading6",
      },
    ],
  },
  htmlSupport: {
    allow: [
      {
        name: /^.*$/,
        styles: true,
        attributes: true,
        classes: true,
      },
    ],
  },

  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: "https://",
    decorators: {
      toggleDownloadable: {
        mode: "manual",
        label: "Downloadable",
        attributes: {
          download: "file",
        },
      },
    },
  },
  placeholder: "Type or paste your content here!",
};

const validationSchema = topicSchema;

const AddTopic = () => {
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const [contentDetails, setContentDetails] = useState([
    {
      description: "",
      images: [],
      videos: [],
      accordianFeatures: [],
    },
  ]);
  const [charCount, setCharCount] = useState(0);
  const charLimit = 1200; // Set your character limit here
  // States for cropping functionality
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageIndexForCropping, setImageIndexForCropping] = useState(null);
  const [descriptionIndexForCropping, setDescriptionIndexForCropping] =
    useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditorVisible, setIsEditorVisible] = useState(false);
  const [descriptionImageIndex, setDescriptionImageIndex] = useState(null);
  const [editorVisibility, setEditorVisibility] = useState([]);

  // Toggle editor visibility
  const handleToggleEditor = (contentIndex) => {
    if (editorVisibility[contentIndex]) {
      // Clear the editor content when closing it
      setContentDetails((prevDetails) => {
        const updatedDetails = [...prevDetails];
        updatedDetails[contentIndex].description = ""; // Clear description or data field
        return updatedDetails;
      });
    }

    setEditorVisibility((prevVisibility) => {
      const updatedVisibility = [...prevVisibility];
      updatedVisibility[contentIndex] = !prevVisibility[contentIndex]; // Toggle visibility at the index
      return updatedVisibility;
    });
  };

  useEffect(() => {
    // Initialize the editor visibility based on whether the description exists
    const visibilityArray = contentDetails.map(
      (content) => !!content.description
    ); // true if description exists, false otherwise
    setEditorVisibility(visibilityArray);
  }, [contentDetails]);

  const Navigate = useNavigate();
  const location = useLocation();

  const handleThumbnailChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      setImageIndexForCropping(null); // Ensure cropping is for thumbnail
      setDescriptionIndexForCropping(null);
      setDescriptionImageIndex(null);
      setIsModalOpen(true);
    }
  };

  const handleAddAccordian = (sectionIndex) => {
    setContentDetails((prevSections) => {
      const updatedSections = [...prevSections];
      updatedSections[sectionIndex].accordianFeatures.push({});
      return updatedSections;
    });
  };
  const handleRemoveAccordian = (sectionIndex, exerciseIndex) => {
    setContentDetails((prevSections) => {
      const updatedSections = [...prevSections];
      updatedSections[sectionIndex].accordianFeatures.splice(exerciseIndex, 1);
      return updatedSections;
    });
  };

  const handleAccordianChange = (sectionIndex, exerciseIndex, field, value) => {
    setContentDetails((prevSections) => {
      const updatedSections = [...prevSections];
      updatedSections[sectionIndex].accordianFeatures[exerciseIndex][field] =
        value;
      return updatedSections;
    });
  };
  // Handle Image Cropping

  const handleCrop = useCallback(async () => {
    setLoading(true);
    try {
      const cloudinaryUrl = await cropAndUploadImage(
        selectedImage,
        croppedAreaPixels
      );
      if (imageIndexForCropping === null) {
        // If cropping thumbnail
        setThumbnail(cloudinaryUrl);
        setThumbnailPreview(cloudinaryUrl);
        formik.setFieldValue("categoryImage", cloudinaryUrl);
      } else {
        // If cropping description image
        const newContentDetails = [...contentDetails];
        if (descriptionIndexForCropping !== null) {
          // Add new image to the existing images array
          newContentDetails[descriptionIndexForCropping].images[
            descriptionImageIndex
          ]["image"] = cloudinaryUrl;
          setContentDetails(newContentDetails);
        }
      }
      setIsModalOpen(false);
      setSelectedImage(null);
    } catch (e) {
      toast.error("Error while cropping or uploading image");
    } finally {
      setLoading(false);
    }
  }, [
    croppedAreaPixels,
    selectedImage,
    imageIndexForCropping,
    descriptionIndexForCropping,
    descriptionImageIndex,
    contentDetails,
  ]);

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  const handleAddImages = (sectionIndex) => {
    setContentDetails((prevSections) => {
      const updatedSections = [...prevSections];
      updatedSections[sectionIndex].images.push({
        redirectUrl: "",
        image: "",
      });
      return updatedSections;
    });
  };

  const handleImageUrlChange = (sectionIndex, exerciseIndex, field, value) => {
    setContentDetails((prevSections) => {
      const updatedSections = [...prevSections];
      updatedSections[sectionIndex].images[exerciseIndex][field] = value;
      return updatedSections;
    });
  };

  const handleRemoveImages = (sectionIndex, exerciseIndex) => {
    setContentDetails((prevSections) => {
      const updatedSections = [...prevSections];
      updatedSections[sectionIndex].images.splice(exerciseIndex, 1);
      return updatedSections;
    });
  };
  const handleFileSelectImage = async (contentIndex, imagesIndex, event) => {
    const file = event.target.files[0];
      try {
      // Crop the image
      
      const formData = new FormData();
      formData.append("file", file);
  
      // Upload to Cloudinary
      const uploadRes = await postDataHandler("uploadFile", formData);
      if (uploadRes.responseCode === 200) {
        const newContentDetails = [...contentDetails];
        if (contentIndex !== null) {
          // Add new image to the existing images array
          newContentDetails[contentIndex].images[
            imagesIndex
          ]["image"] = uploadRes.result;
          setContentDetails(newContentDetails);
        }
        
      } else {
        throw new Error("Error while uploading file");
      }
    } catch (error) {
      console.error(error);
      throw error; // Re-throw the error to be handled by the calling code
    }



    // if (file) {
    //   setSelectedImage(URL.createObjectURL(file));
    //   setImageIndexForCropping(0); // Assuming adding new image to existing list
    //   setDescriptionIndexForCropping(contentIndex);
    //   setDescriptionImageIndex(imagesIndex);
    //   setIsModalOpen(true);
    // }
  };


   const handleFileSelectImage2 = async (contentIndex, imagesIndex, event) => {
    const file = event.target.files[0];


  }
  const handleRemoveImage = (sectionIndex, imageIndex) => {
    const newContentDetails = [...contentDetails];
    newContentDetails[sectionIndex].images[imageIndex].image = "";
    setContentDetails(newContentDetails);
  };

  // Add More Sections
  const handleAddValueContent = () => {
    setContentDetails([
      ...contentDetails,
      {
        description: "",
        images: [],
        videos: [],
        accordianFeatures: [],
      },
    ]);
  };
  // Remove Section
  const handleRemoveStepContent = (index) => {
    if (contentDetails.length > 1) {
      const newContentDetails = contentDetails.filter((_, i) => i !== index);
      setContentDetails(newContentDetails);
    } else {
      toast.error("You must have at least one description section.");
    }
  };
  const handleAddVideo = (sectionIndex) => {
    setContentDetails((prevSections) => {
      const updatedSections = [...prevSections];
      updatedSections[sectionIndex].videos.push({});
      return updatedSections;
    });
  };
  const handleVideoChange = (sectionIndex, exerciseIndex, field, value) => {
    setContentDetails((prevSections) => {
      const updatedSections = [...prevSections];
      updatedSections[sectionIndex].videos[exerciseIndex][field] = value;
      return updatedSections;
    });
  };

  const handleRemoveVideo = (sectionIndex, exerciseIndex) => {
    setContentDetails((prevSections) => {
      const updatedSections = [...prevSections];
      updatedSections[sectionIndex].videos.splice(exerciseIndex, 1);
      return updatedSections;
    });
  };

  const handleSaveAsChange = (event) => {
    formik.handleChange(event);
    formik.setFieldValue("saveAs", event.target.value);
  };

  // Formik
  const formik = useFormik({
    initialValues: {
      topicName: "",
      contentDetails: [],
      categoryImage: "",
      saveAs: "FREE",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      console.log("Form submitted with values:", values);
      const data = {
        programId: location.state.programId,
        topicName: values.topicName,
        topicThumbnailImage: thumbnail,
        contentDetails: contentDetails,
        saveAs: values.saveAs,

      };

     
      try {
        setLoading(true);
        const res = await postDataHandlerWithToken("addUpdateTopic", data);
        if (res.responseCode === 200) {
          toast.success(res.responseMessage);
          Navigate("/topiclisting/programsTopic", {
            state: { programId: location.state.programId },
          });
        } else {
          toast.error(res.data.responseMessage);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <DashboardLayout
      sectionName="Content - Program Management"
      title="Add Topic"
    >
      <Box className="heading-container-top">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Box>
            <img
              src={backBtn}
              alt="backBtn"
              style={{ cursor: "pointer" }}
              onClick={() => Navigate(-1)}
            />
          </Box>
          <Typography sx={{ ...typographyStyles.h4 }}>Add Topic</Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="add-edit-container">
        <form
          className="add-edit-content-section"
          onSubmit={formik.handleSubmit}
        >
          <Box className="add-edit-content">
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Topic Name:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
                <InputField
                  type="text"
                  name="topicName"
                  value={formik.values.topicName}
                  maxLength={100}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter topic name"
                />
                {formik.errors.topicName && formik.touched.topicName ? (
                  <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                    {formik.errors.topicName}
                  </p>
                ) : null}
              </Box>
            </Box>
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Topic Thumbnail Image:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
                <InputField
                  type="file"
                  name="categoryImage"
                  onChange={handleThumbnailChange}
                  onBlur={formik.handleBlur}
                  acceptedFile="image/*"
                />
                {formik.errors.categoryImage && formik.touched.categoryImage ? (
                  <p style={{ color: "red", marginTop: "5px", float: "left" }}>
                    {formik.errors.categoryImage}
                  </p>
                ) : null}

                {thumbnailPreview && (
                  <Box>
                    <Card
                      sx={{ maxWidth: 250, maxHeight: "auto", margin: "5px" }}
                    >
                      <CardMedia component="img" image={thumbnailPreview} />
                    </Card>
                  </Box>
                )}
              </Box>
            </Box>
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>Save As:</Typography>
              </Box>
              <Box className="add-edit-input-field">
                <FormControl>
                  <RadioGroup
                    name="saveAs"
                    value={formik.values.saveAs}
                    onChange={handleSaveAsChange}
                  >
                    <FormControlLabel
                      value="FREE"
                      control={<Radio />}
                      label="Free"
                    />
                    <FormControlLabel
                      className="radio"
                      value="LOCKED"
                      control={<Radio />}
                      label="Locked (will be accessed after subscription)"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={{ ...typographyStyles.h6 }}>
                  Description Section:
                </Typography>
              </Box>
              <Box
                className="add-edit-input-field ckeditor-container"
                sx={{ width: "100%" }}
              >
                {contentDetails?.map((content, contentIndex) => (
                  <Box key={contentIndex} mb={1}>
                    <Grid sx={commonGridStyle}>
                      <Box className="add-edit-input-field">
                        <Button
                          sx={{
                            backgroundColor: "rgb(225, 140, 168)",
                            textTransform: "none",

                            minWidth: "30%",
                          }}
                          variant="contained"
                          onClick={() => handleToggleEditor(contentIndex)}
                          startIcon={
                            editorVisibility[contentIndex] ? (
                              <RemoveIcon />
                            ) : (
                              <AddIcon />
                            )
                          }
                        >
                          {editorVisibility[contentIndex]
                            ? "Remove Description"
                            : "Add Description"}
                        </Button>

                        <Grid className="ckeditor-container" mb={1} mt={1}>
                          {editorVisibility[contentIndex] && (
                            <CKEditor
                              editor={ClassicEditor}
                              data={content.description || ""}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                const newContentDetails = [...contentDetails];
                                newContentDetails[contentIndex].description =
                                  data;
                                setContentDetails(newContentDetails);
                                formik.setFieldValue(
                                  "contentDetails",
                                  newContentDetails
                                );
                              }}
                              config={editorConfig}
                              className="StaticEditor"
                            />
                          )}

                          {/* Formik validation errors */}
                          {formik.touched.contentDetails?.[contentIndex]
                            ?.description &&
                            formik.errors.contentDetails?.[contentIndex]
                              ?.description && (
                              <p
                                style={{
                                  color: "red",
                                  marginTop: "5px",
                                  float: "left",
                                }}
                              >
                                {
                                  formik.errors.contentDetails[contentIndex]
                                    .description
                                }
                              </p>
                            )}
                        </Grid>
                      </Box>

                      <Box className="add-edit-input-field">
                        <Box>
                          {content?.images?.map((image, imageIndex) => (
                            <Card key={imageIndex} sx={{ padding: 1, mb: 2 }}>
                              <InputField
                                placeholder={` Image Redirect URL ${
                                  imageIndex + 1
                                }`}
                                value={image.redirectUrl}
                                maxLength={200}
                                onChange={(e) =>
                                  handleImageUrlChange(
                                    contentIndex,
                                    imageIndex,
                                    "redirectUrl",
                                    e.target.value
                                  )
                                }
                                fullWidth
                              />

                              <Grid
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Button
                                  sx={{
                                    backgroundColor: "rgb(225, 140, 168)",
                                    textTransform: "none",
                                    mt: 1,
                                  }}
                                  variant="contained"
                                  component="label"
                                  startIcon={<UploadIcon />}
                                >
                                  Upload
                                  <input
                                    type="file"
                                    accept="image/*"
                                    hidden
                                    onChange={(event) =>
                                      handleFileSelectImage(
                                        contentIndex,
                                        imageIndex,
                                        event
                                      )
                                    }
                                  />
                                </Button>

                                <IconButton
                                  sx={{ ...addEditStyle.addRemoveButton }}
                                  onClick={() =>
                                    handleRemoveImages(contentIndex, imageIndex)
                                  }
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>

                              {image.image && (
                                <Card sx={{ maxWidth: 200, margin: "5px" }}>
                                  <CardMedia
                                    component="img"
                                    image={image.image}
                                    alt={`image ${imageIndex + 1}`}
                                  />
                                  <IconButton
                                    onClick={() =>
                                      handleRemoveImage(
                                        contentIndex,
                                        imageIndex
                                      )
                                    }
                                    sx={{ color: "rgb(225, 140, 168)" }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Card>
                              )}
                            </Card>
                          ))}
                        </Box>
                        <Button
                          sx={{
                            backgroundColor: "rgb(225, 140, 168)",
                            textTransform: "none",
                            mb: 2,
                            width: "30%",
                          }}
                          variant="contained"
                          component="label"
                          onClick={() => handleAddImages(contentIndex)}
                          startIcon={<AddIcon />}
                        >
                          Add Images
                        </Button>
                      </Box>

                      <Box className="add-edit-input-field">
                        {content?.videos?.map((video, videoIndex) => (
                          <Box key={videoIndex}>
                            <Grid
                              container
                              alignItems="center"
                              sx={commonGridStyle}
                            >
                              {/* Video Title */}
                              <Grid item xs={12}>
                                <InputField
                                  placeholder={`Video title ${videoIndex + 1}`}
                                  value={video.title}
                                  maxLength={200}
                                  onChange={(e) =>
                                    handleVideoChange(
                                      contentIndex,
                                      videoIndex,
                                      "title",
                                      e.target.value
                                    )
                                  }
                                  fullWidth
                                />
                              </Grid>

                              {/* Video Script */}
                              <Grid item xs={12} mt={2}>
                                <InputField
                                  placeholder={`Video script ${videoIndex + 1}`}
                                  value={video.videoScript}
                                  onChange={(e) =>
                                    handleVideoChange(
                                      contentIndex,
                                      videoIndex,
                                      "videoScript",
                                      e.target.value
                                    )
                                  }
                                  fullWidth
                                />
                              </Grid>

                              {/* Video HLS Link */}
                              <Grid item xs={12} mt={2} mb={2}>
                                <InputField
                                  placeholder={`Video HLS link ${
                                    videoIndex + 1
                                  }`}
                                  value={video.videoHls}
                                  onChange={(e) =>
                                    handleVideoChange(
                                      contentIndex,
                                      videoIndex,
                                      "videoHls",
                                      e.target.value
                                    )
                                  }
                                  fullWidth
                                />
                              </Grid>

                              {/* Add/Remove buttons for videos */}
                              <Grid item xs={12}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "10px",
                                    mt: "5px",
                                  }}
                                >
                                  {/* Remove Video Button */}
                                  {content.videos.length > 0 && (
                                    <IconButton
                                      sx={{ ...addEditStyle.addRemoveButton }}
                                      onClick={() =>
                                        handleRemoveVideo(
                                          contentIndex,
                                          videoIndex
                                        )
                                      }
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  )}
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        ))}
                        <Button
                          sx={{
                            backgroundColor: "rgb(225, 140, 168)",
                            textTransform: "none",
                            width: "30%",
                          }}
                          variant="contained"
                          component="label"
                          onClick={() => handleAddVideo(contentIndex)}
                          startIcon={<AddIcon />}
                        >
                          Add Videos
                        </Button>
                      </Box>

                      <Box className="add-edit-input-field">
                        {content?.accordianFeatures?.map(
                          (accordian, accordianIndex) => (
                            <Box key={accordianIndex}>
                              <Grid container sx={commonGridStyle} mt={2}>
                                <Grid item xs={6} md={12} width="100%" mb={2}>
                                  <InputField
                                    label="Title"
                                    placeholder={`Accordian title ${
                                      accordianIndex + 1
                                    }`}
                                    value={accordian.title}
                                    onChange={(e) =>
                                      handleAccordianChange(
                                        contentIndex,
                                        accordianIndex,
                                        "title",
                                        e.target.value
                                      )
                                    }
                                  />

                                  {/* {formik.touched.accordianFeatures?.[
                                  accordianIndex
                                ]?.title &&
                                  formik.errors.accordianFeatures?.[
                                    accordianIndex
                                  ]?.title && (
                                    <p
                                      style={{
                                        color: "red",
                                        marginTop: "5px",
                                        float: "left",
                                      }}
                                    >
                                      {
                                        formik.errors
                                          .accordianFeatures?.[accordianIndex]
                                          ?.title
                                      }
                                    </p>
                                  )} */}
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  md={12}
                                  className="add-edit-input-field ckeditor-container"
                                  sx={{ width: "100%" }}
                                >
                                  <CKEditor
                                    editor={ClassicEditor}
                                    data={accordian.description || ""}
                                    onChange={(e, editor) =>
                                      handleAccordianChange(
                                        contentIndex,
                                        accordianIndex,
                                        "description",
                                        editor.getData()
                                      )
                                    }
                                    config={editorConfig}
                                    className="StaticEditor"
                                  />

                                  {/* {formik.touched.accordianFeatures?.[
                                  index
                                ]?.description &&
                                  formik.errors.accordianFeatures?.[
                                    index
                                  ]?.description && (
                                    <p
                                      style={{
                                        color: "red",
                                        marginTop: "5px",
                                        float: "left",
                                      }}
                                    >
                                      {
                                        formik.errors
                                          .accordianFeatures?.[index]
                                          ?.description
                                      }
                                    </p>
                                  )} */}
                                </Grid>
                                <Grid item xs={12}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      gap: "10px",
                                      mt: "5px",
                                    }}
                                  >
                                    {
                                      <IconButton
                                        sx={{ ...addEditStyle.addRemoveButton }}
                                        onClick={() =>
                                          handleRemoveAccordian(
                                            contentIndex,
                                            accordianIndex
                                          )
                                        }
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    }
                                    {/* {index ===
                                    accordionTitleDescriptions.length - 1 && (
                                    <IconButton
                                      onClick={() =>
                                        handleAddValueTapsAcco(
                                          accordionTitleDescriptions,
                                          setAccordionTitleDescriptions
                                        )
                                      }
                                      sx={addEditStyle.addRemoveButton}
                                    >
                                      <AddCircleOutlineRoundedIcon />
                                    </IconButton>
                                  )} */}
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                          )
                        )}
                        <Button
                          sx={{
                            backgroundColor: "rgb(225, 140, 168)",
                            textTransform: "none",
                            mb: 2,
                            width: "30%",
                            mt: 2,
                          }}
                          variant="contained"
                          component="label"
                          onClick={() => handleAddAccordian(contentIndex)}
                          startIcon={<AddIcon />}
                        >
                          Add Accordian
                        </Button>
                      </Box>
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          {/* Remove content if more than 1 */}
                          {contentDetails?.length > 1 && (
                            <Grid
                              item
                              xs={2}
                              md={1}
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <IconButton
                                onClick={() =>
                                  handleRemoveStepContent(
                                    contentIndex,
                                    contentDetails,
                                    setContentDetails,
                                    "contentDetails"
                                  )
                                }
                                sx={{ ...addEditStyle.addRemoveButton }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Grid>
                          )}
                          {/* Add new content */}
                          {contentIndex === contentDetails?.length - 1 && (
                            <Grid
                              item
                              xs={2}
                              md={1}
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <IconButton
                                onClick={() =>
                                  handleAddValueContent(
                                    contentDetails,
                                    setContentDetails
                                  )
                                }
                                sx={addEditStyle.addRemoveButton}
                              >
                                <AddCircleOutlineRoundedIcon />
                              </IconButton>
                            </Grid>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
          <Box
            className="add-edit-button-section "
            sx={{ alignItems: "center", justifyContent: "center" }}
          >
            <BasicButtons
              text={"Cancel"}
              onClick={() => Navigate(-1)}
              disabled={loading}
              width="25%"
            />
            <BasicButtons
              type="submit"
              text={"Save"}
              loading={loading}
              width="25%"
            />
          </Box>
        </form>
      </Box>
      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={() => handleCancel()}
        style={modalStyles}
        contentLabel="Crop Image"
      >
        <div style={modalStyles.cropperContainer}>
          <Cropper
            image={selectedImage}
            crop={crop}
            zoom={zoom}
            aspect={21 / 9}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={(croppedArea, croppedAreaPixels) =>
              setCroppedAreaPixels(croppedAreaPixels)
            }
          />
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              p: 2,
              gap: 5,
            }}
          >
            <BasicButtons text="Cancel" onClick={handleCancel} />
            <BasicButtons text="Crop" onClick={handleCrop} loading={loading} />
          </Box>
        </div>
      </ReactModal>
    </DashboardLayout>
  );
};

export default AddTopic;
